import { Action, createAction, createReducer, on, props } from '@ngrx/store';

interface WaterMark {
  includeContent: string[];
  showMode: string;
  showOnPdf: boolean | string;
}

export const setWaterMark = createAction('[WaterMark] Set WaterMark Info', props<WaterMark>());

export function watermarkReducer(watermark: WaterMark | undefined, action: Action) {
  return createReducer(
    {},
    on(setWaterMark, (state, watermark) => watermark)
  )(watermark, action);
}
